var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHr7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 32.5C10.3978 32.5 10.7794 32.658 11.0607 32.9393C11.342 33.2206 11.5 33.6022 11.5 34V38C11.5 38.276 11.724 38.5 12 38.5H36C36.1326 38.5 36.2598 38.4473 36.3536 38.3536C36.4473 38.2598 36.5 38.1326 36.5 38V34C36.5 33.6022 36.658 33.2206 36.9393 32.9393C37.2206 32.658 37.6022 32.5 38 32.5C38.3978 32.5 38.7794 32.658 39.0607 32.9393C39.342 33.2206 39.5 33.6022 39.5 34V38C39.5 38.9283 39.1313 39.8185 38.4749 40.4749C37.8185 41.1313 36.9283 41.5 36 41.5H12C11.0717 41.5 10.1815 41.1313 9.52513 40.4749C8.86875 39.8185 8.5 38.9283 8.5 38V34C8.5 33.6022 8.65804 33.2206 8.93934 32.9393C9.22064 32.658 9.60218 32.5 10 32.5Z",
    fill: "url(#paint0_linear_1714_4859)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4777 7.50001C20.9811 7.49922 20.5023 7.68506 20.1363 8.02068C19.7703 8.35631 19.5438 8.81721 19.5017 9.31201C19.1965 12.817 19.1417 16.3392 19.3377 19.852C18.8443 19.8787 18.351 19.91 17.8577 19.946L14.8777 20.164C14.6152 20.1832 14.3623 20.2703 14.1435 20.4166C13.9248 20.5629 13.7478 20.7635 13.6299 20.9988C13.512 21.234 13.4572 21.4959 13.4708 21.7587C13.4844 22.0215 13.566 22.2762 13.7077 22.498C15.8332 25.8209 18.5695 28.7106 21.7717 31.014L22.9657 31.872C23.2678 32.0883 23.6301 32.2046 24.0017 32.2046C24.3732 32.2046 24.7355 32.0883 25.0377 31.872L26.2317 31.014C29.4338 28.7106 32.1702 25.8209 34.2957 22.498C34.4373 22.2762 34.5189 22.0215 34.5325 21.7587C34.5462 21.4959 34.4913 21.234 34.3734 20.9988C34.2555 20.7635 34.0785 20.5629 33.8598 20.4166C33.6411 20.2703 33.3881 20.1832 33.1257 20.164L30.1457 19.946C29.6526 19.9103 29.1593 19.879 28.6657 19.852C28.8623 16.3393 28.8082 12.817 28.5037 9.31201C28.4615 8.81686 28.2347 8.35568 27.8683 8.02001C27.5018 7.68433 27.0226 7.49872 26.5257 7.50001H21.4777Z",
    fill: "url(#paint1_linear_1714_4859)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1714_4859",
    x1: 8.5,
    y1: 31.375,
    x2: 13.2721,
    y2: 49.3785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6EB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1714_4859",
    x1: 13.4688,
    y1: 4.41193,
    x2: 39.8526,
    y2: 29.0536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6EB5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHr7);
export default __webpack_public_path__ + "static/media/Hr7.a3f603bd061cd2944df0b4357a256338.svg";
export { ForwardRef as ReactComponent };